import React from "react";
import { memo } from "react";
import _ from "lodash";
import { Button, Popconfirm, Switch } from "antd";
import { FaPencilAlt } from "react-icons/fa";
import { Table } from "react-bootstrap";
import { fourPlaceHolder } from "modules/utilities/utility";
function CallProviders({
  callProvidersResponse,
  handleToggleCallProvider,
  handleUpdateCallProviderDetails,
  isCallProviderLoading,
}) {
  const { data } = callProvidersResponse;

  return (
    <div>
      <div className="d-flex justify-content-end gap-2">
        <Button
          type="primary"
          onClick={() => handleToggleCallProvider({ type: "new" })}
        >
          Create Call Provider
        </Button>
      </div>
      <Table responsive className="mt-2">
        <thead>
          <tr>
            <th>#</th>
            <th>Provider</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {isCallProviderLoading
              ? Array.from({ length: 4 }, (_, index) => (
                  <td key={index}>{fourPlaceHolder()}</td>
                ))
              : null}
          </tr>
          {Array.isArray(data) &&
            data.map((provider, index) => (
              <tr key={provider?.id}>
                <td>{index + 1}</td>
                <td>{provider?.provider_name}</td>
                <td>
                  <Popconfirm
                    title="Status"
                    description={`All users associated with provider ${
                      provider?.provider_name
                    } will ${
                      provider?.is_active ? "be disabled" : "be enabled"
                    } for calls.`}
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() =>
                      handleUpdateCallProviderDetails({
                        key: "isActive",
                        value: !provider?.is_active,
                        providerId: provider?.id,
                      })
                    }
                  >
                    <Switch size="small" checked={provider?.is_active} />
                  </Popconfirm>
                </td>
                <td>
                  <Button
                    type="text"
                    shape="circle"
                    icon={<FaPencilAlt />}
                    onClick={() =>
                      handleToggleCallProvider({ provider, type: "edit" })
                    }
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
}

export default memo(CallProviders);
